module.exports = __webpack_public_path__ + "static/media/catalouge-32.3fc8858d.jpg";